import React, { useState, useEffect, useRef } from 'react';
import {Spinner, Button} from 'react-bootstrap';
import { useParams, withRouter } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import {
    createProviderAction,
    updateProviderAction,
    startLoader,
    getProvidersTypesAction,
    getProviderDataAction,
    emptyProviderDataAction
} from '../../../../store/actions/ProviderActions';
import { getProfilAction } from '../../../../store/actions/UserAction';
import { currentUser } from "../../../../store/selectors/CurrentUserSelector";
import { getParameterAction
} from '../../../../store/actions/AdministrationAction';
import SelectSearch from "react-select-search";
import '../../Clients/Styles/selectStyle.css';
import Select from 'react-select';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Steps } from 'primereact/steps';
import { useTranslation } from "react-i18next";
//import './ProviderForm.css';

const ProviderForm = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [activeIndex, setActiveIndex] = useState(0);
    const [localLoader, setLocalLoader] = useState(false);
    const { id } = useParams();
    const { providers, provider, history, showLoading } = props;

    const items = [
        {
            label: t("client.gen-info")
        },
        {
            label: t("common.admin-info")
        },
        {
            label: t("client.localization")
        },
        {
            label: t("common.payemnt-info")
        },
        {
            label: t('client.confirmation')
        }
    ];

    const [choosenCountry, setChoosenCountry] = useState([]);
    
    const [providerTypeId, setProviderTypeId] = useState([]);
    const [providerName, setProviderName] = useState("");
    const [numeroAutorisation, setNumeroAutorisation] = useState("");
    const [numeroAutorisationGouv, setNumeroAutorisationGouv] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [whatsappPhone, setWhatsappPhone] = useState("");
    const [email, setEmail] = useState("");
    const [imgSrc, setImgSrc] = useState(null);
    const [status, setStatus] = useState(true);
    const [conventionDate, setConventionDate] = useState(new Date().toISOString().split('T')[0]);

    const [lon, setLon] = useState(0);
    const [lat, setLat] = useState(0);
    const [postal, setPostal] = useState("");
    const [cityId, setCityId] = useState("");
    const [countryId, setCountryId] = useState("");
    
    const [conventionNumber, setConventionNumber] = useState("");
    const [niu, setNiu] = useState("");
    const [taxType, setTaxType] = useState("");
    const [taxValue, setTaxValue] = useState("");
    const [contribuable, setContribuable] = useState("");
    const [exerciceYear, setExerciceYear] = useState(2022);
    
    const [identity, setIdentity] = useState('Médecin');
    const [profilIds, setProfilIds] = useState([]);
    const [tarifId, setTarifId] = useState(0);
    // Bank details - correspondant à la structure API
    const [bankDetails, setBankDetails] = useState([]);
    
    // Mobile payment details - correspondant à la structure API
    const [mobilePaymentDetails, setMobilePaymentDetails] = useState([]);
    
    // Bank details - matching JSON structure
    const [bankDetail, setBankDetail] = useState({
        bankName: "",
        bankCode: "",
        swift: "",
        accountName: "",
        accountNumber: "",
        rib: "",
        ribPhoto: null
    });
 
    const [paymentMeans, setPaymentMeans] = useState([]);
    

    const canDo = (menuCode, actionCode) => {
        let theMenu = props.currentUser.menus?.find(menu => menu.code === menuCode);
        if(!theMenu){
            return false;
        }else{
            return theMenu.actionMenus?.filter(action => action.code === actionCode).length > 0;
        }
    }
    
    const hasMenu = (menuCode) => {
        return props.currentUser.menus?.filter(menu => menu.code === menuCode).length > 0;
    }

    useEffect(() => {
        if(hasMenu('MENPRESTATAIREADMIN') && (canDo('MENPRESTATAIREADMIN', 'CREATEPRESTATAIRE') || canDo('MENPRESTATAIREADMIN', 'UPDATEPRESTATAIRE'))){
            dispatch(emptyProviderDataAction());
            setLocalLoader(true);
            if(id){
                dispatch(startLoader());
                dispatch(getProviderDataAction(id, history));
            }
            dispatch(getParameterAction());
            dispatch(getProvidersTypesAction());  
            dispatch(getProfilAction());
        }else{
            props.history.push('/access-denied');
        }  
    }, []);

    useEffect(() => {
        if(id && Object.keys(provider).length > 0 && props.providerTypes.length > 0 && props.profilsData.length > 0){
            console.log(Object.keys(provider).length);
            setProviderTypeId(provider.type?.map(elt => {return elt.providerTypeId}));
            setProviderName(provider.providerName);
            setNumeroAutorisation(provider.numeroAutorisation);
            setNumeroAutorisationGouv(provider.numeroAutorisationGouv);
            setPhoneNumber(provider.phoneNumber);
            setWhatsappPhone(provider.whatsappPhone);
            setEmail(provider.email);
            setStatus(provider.status !== undefined ? provider.status : true);
            setConventionDate(provider.conventionDate ? provider.conventionDate.split('T')[0] : new Date().toISOString().split('T')[0]);
        
            setLon(provider.lon);
            setLat(provider.lat);
            setPostal(provider.postal);
            setCityId(provider.cityId);
            setCountryId(provider.countryId);
            
            setConventionNumber(provider.conventionNumber);
            setNiu(provider.niu);
            setTaxType(provider.details ? provider.details[provider.details.length - 1]?.taxType : "");
            setTaxValue(provider.details ? provider.details[provider.details?.length - 1]?.taxValue : "");
            setContribuable(provider.contribuable);
            setExerciceYear(provider.details ? provider.details[provider.details?.length - 1]?.exerciceYear : 2022); 
            setProfilIds(provider.profils?.map(elt => {return elt.id}) || []);
            setTarifId(provider.tarifId || 0);

            // Set bank details
            // Mise à jour des détails bancaires
            if(provider.bankDetails && provider.bankDetails.length > 0) {
                setBankDetails(provider.bankDetails.map(bd => ({
                    id: bd.id,
                    providerId: bd.providerId,
                    bankName: bd.bankName || "",
                    bankCode: bd.bankCode || "",
                    swift: bd.swift || "",
                    accountName: bd.accountName || "",
                    accountNumber: bd.accountNumber || "",
                    rib: bd.rib || "",
                    ribPhoto: bd.ribPhoto || null
                })));
            }

            // Mise à jour des moyens de paiement mobile
            if(provider.mobilePaymentDetails && provider.mobilePaymentDetails.length > 0) {
                setMobilePaymentDetails(provider.mobilePaymentDetails.map(mpd => ({
                    id: mpd.id || Math.random(),
                    operator: mpd.operator || "",
                    phoneNumber: mpd.phoneNumber || "",
                    beneficialName: mpd.beneficialName || "",
                    idNumber: mpd.idNumber || "",
                    idType: mpd.idType || "",
                    file: null
                })));
            }

            setLocalLoader(false);
        }else{
            setLocalLoader(false);
        }
    }, [provider, props.providerTypes, props.profilsData]);

    useEffect(() => {
        if(id && provider && props.admin.countries) {
            setChoosenCountry(props.admin.countries?.filter((country) =>{return country.id === provider.countryId}));
        }
    }, [props.admin, provider]);

    const saveFile = (e) => {
        let upFiles = e.target.files;
        const keys = Object.keys(upFiles);
        setImgSrc(upFiles[keys[0]]);
    }

    // const addRIB = (e) => {
    //     let upFiles = e.target.files;
    //     const keys = Object.keys(upFiles);
    //     setBankDetail(prev => ({
    //         ...prev,
    //         ribPhoto: 'test.jpg', // Placeholder, as the actual file will be handled separately
    //        // ribPhoto: upFiles[keys[0]] ?? null
    //     }));
    // }

    // const loadIdentityFile = (e, paymentMean) => {
    //     let upFiles = e.target.files;
    //     const keys = Object.keys(upFiles);
    //     setPaymentMeans(paymentMeans.map(payM => { 
    //         if(payM.id === paymentMean.id){
    //             payM.file = upFiles[keys[0]];
    //         }
    //         return payM;
    //     }));
    // }

    // const updateBankDetail = (field, value) => {
    //     setBankDetail(prev => ({
    //         ...prev,
    //         [field]: value
    //     }));
    // }
// Fonction pour ajouter un nouveau détail bancaire
const addBankDetail = () => {
    setBankDetails([...bankDetails, {
        id: 0, // 0 pour un nouveau détail
        providerId: id ? parseInt(id) : 0,
        bankName: "",
        bankCode: "",
        swift: "",
        accountName: "",
        accountNumber: "",
        rib: "",
        ribPhoto: null
    }]);
};

// Fonction pour mettre à jour un détail bancaire spécifique
const updateBankDetail = (index, field, value) => {
    setBankDetails(bankDetails.map((bd, i) => 
        i === index ? { ...bd, [field]: value } : bd
    ));
};

// Fonction pour supprimer un détail bancaire
const removeBankDetail = (index) => {
    setBankDetails(bankDetails.filter((_, i) => i !== index));
};

// Fonction pour ajouter un fichier RIB à un détail bancaire spécifique
const addRIB = (e, index) => {
    let upFiles = e.target.files;
    const keys = Object.keys(upFiles);
    if (upFiles[keys[0]]) {
        updateBankDetail(index, 'ribPhoto', upFiles[keys[0]]);
    }
};

// Fonction pour charger un fichier d'identité pour un moyen de paiement mobile
const loadIdentityFile = (e, paymentDetail) => {
    let upFiles = e.target.files;
    const keys = Object.keys(upFiles);
    if (upFiles[keys[0]]) {
        setMobilePaymentDetails(mobilePaymentDetails.map(mpd => 
            mpd.id === paymentDetail.id ? {...mpd, file: upFiles[keys[0]]} : mpd
        ));
    }
};
// Mise à jour de la fonction onSave pour gérer les listes
async function onSave(e) {
    e.preventDefault();
    dispatch(startLoader());

    // Filtrer les détails bancaires valides (avec au moins un nom de banque)
    const validBankDetails = bankDetails.filter(bd => bd.bankName.trim().length > 0);
    
    // Filtrer les moyens de paiement mobile valides (avec au moins un opérateur)
    const validMobilePayments = mobilePaymentDetails.filter(mpd => mpd.operator.trim().length > 0);

    if(id) {
        let providerDatas = {
            providerName,
            phoneNumber,
            whatsappPhone,
            lon,
            lat,
            postal,
            numeroAutorisation,
            contribuable,
            status,
            cityId,
            countryId,
            providerTypeId,
            email,
            conventionDate: new Date(conventionDate).toISOString(),
            niu,
            details: {
                id: provider.details && provider.details.length > 0 ? provider.details[provider.details.length - 1]?.id : 0,
                providerId: parseInt(id),
                taxType,
                taxValue,
                exerciceYear: parseInt(exerciceYear),
                status: true
            },
            // Envoyer tous les détails bancaires valides
            bankDetails: validBankDetails.map(bd => ({
                id: bd.id || 0,
                providerId: parseInt(id),
                bankName: bd.bankName,
                bankCode: bd.bankCode,
                swift: bd.swift,
                accountName: bd.accountName,
                accountNumber: bd.accountNumber,
                rib: bd.rib,
                ribPhoto: bd.ribPhoto
            })),
            // Envoyer tous les moyens de paiement mobile valides
            mobilePaymentDetails: validMobilePayments.map(mpd => ({
                id: typeof mpd.id === 'number' && mpd.id !== Math.floor(Math.random() * 1000000) ? mpd.id : 0,
                providerId: parseInt(id),
                operator: mpd.operator,
                phoneNumber: mpd.phoneNumber,
                beneficialName: mpd.beneficialName,
                idNumber: mpd.idNumber,
                idType: mpd.idType,
                idPhoto: mpd.file || mpd.idPhoto
            })),
            profils: profilIds,
            tarifId
        };
        dispatch(updateProviderAction(imgSrc, id, providerDatas, props.history));
    } else {
        // Logique similaire pour la création
        let providerDatas = {
            providerName,
            phoneNumber,
            whatsappPhone,
            lon,
            lat,
            postal,
            numeroAutorisation,
            contribuable,
            status,
            cityId,
            countryId,
            providerTypeId,
            email,
            conventionDate: new Date(conventionDate).toISOString(),
            niu,
            details: {
                taxType,
                taxValue,
                exerciceYear: parseInt(exerciceYear),
                status: true
            },
            bankDetails: validBankDetails,
            mobilePaymentDetails: validMobilePayments,
            profils: profilIds,
            tarifId
        };
        dispatch(createProviderAction(imgSrc, providerDatas, props.history));
    }
}

// Mise à jour de la validation canGoNext pour la case 3
const canGoNext = (index) => {
    switch (index) {
        case 0:
            return providerName?.trim().length > 0 &&
                    providerTypeId?.length > 0 && 
                    numeroAutorisation?.trim().length > 0 &&
                    email?.trim().length > 0 &&
                    phoneNumber?.trim().length > 0 &&
                    (id ? true : profilIds.length > 0);
        case 1:
            return niu?.trim().length > 0 && 
                    taxType?.trim().length > 0 &&
                    taxValue?.toString().trim().length > 0 &&
                    exerciceYear >= 2022 &&
                    contribuable?.trim().length > 0;
        case 2:
            return cityId && countryId;
        case 3:
            // Validation des détails bancaires
            for(let bankDetail of bankDetails) {
                if(bankDetail.bankName.trim().length > 0) {
                    if(bankDetail.accountName.trim().length === 0 || 
                       bankDetail.bankCode.trim().length === 0 || 
                       bankDetail.swift.trim().length === 0 || 
                       bankDetail.accountNumber.trim().length === 0 || 
                       bankDetail.rib.trim().length === 0 ||
                       !bankDetail.ribPhoto) {
                        return false;
                    }
                }
            }

            // Validation des moyens de paiement mobile
            for(let mpd of mobilePaymentDetails) {
                if(mpd.operator.trim().length > 0) {
                    if(mpd.phoneNumber.trim().length === 0 || 
                       mpd.beneficialName.trim().length === 0 || 
                       mpd.idType.trim().length === 0 || 
                       mpd.idNumber.trim().length === 0 || 
                       (!mpd.file && !mpd.idPhoto)) {
                        return false;
                    }
                }
            }
    
            return true;
        default:
            return false;
    }
};
    const canSubmitForm = () => {
        return canGoNext(0) && canGoNext(1) && canGoNext(2) && canGoNext(3);
    }

    const isFormReady = () => {
        if(id) {
            return providerName === provider.providerName
        }else{
            return true
        }
    }

    return (
        <>
            { (props.showLoading || localLoader || !isFormReady()) && 
            <div id="preloader">
                <div className="sk-three-bounce">
                    <div className="sk-child sk-bounce1"></div>
                    <div className="sk-child sk-bounce2"></div>
                    <div className="sk-child sk-bounce3"></div>
                </div>
            </div> }
            { (!props.showLoading && !localLoader && isFormReady()) &&<div className="card py-4">
                <h3 className='text-center mb-4 '>
                    {
                        id ?  "Mise à jour du prestataire: "+ provider.providerName : "Nouveau prestataire"
                    }
                </h3>
                <Steps model={items} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={!canSubmitForm()} />
                
                <form onSubmit={onSave}>
                    {activeIndex === 0 && <div className='px-5 pt-5'>
                        <div className='row justify-content-between align-items-center'>
                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t("provider.promoter")}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <select
                                    defaultValue={identity}
                                    className='form-control form-control-lg'
                                    onChange={(e) => setIdentity(e.target.value)}
                                >
                                    <option value='option'>
                                       {t("common.choose")}
                                    </option>
                                    <option value='Promoteur'>{t('common.doctor')}</option>
                                    <option value='Médecin'>{t('common.no')} {t('common.doctor')}</option>
                                </select>
                            </div>

                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t("provider.denomination")}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <input type='text' className='form-control'
                                    value={providerName}
                                    disabled={props.showLoading}
                                    required
                                    onChange={(e) => setProviderName(e.target.value)}
                                    />
                            </div>
                                    
                            {(identity === 'Promoteur') && <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t("provider.gouv-number")}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <input type='text' className='form-control'
                                    value={numeroAutorisationGouv}
                                    disabled={props.showLoading}
                                    required={identity === 'Promoteur'}
                                    onChange={(e) => setNumeroAutorisationGouv(e.target.value)}
                                    />
                            </div>}
                        </div>
                        <div className='row justify-content-between align-items-center'>
                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t('client.type')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                
                                <Select
                                    className="select-search"
                                    value={providerTypeId ? props.providerTypes?.filter(type => providerTypeId.includes(type.id))?.map(elt => {return {label:elt.nameFr,value:elt.id}}) : []}
                                    isMulti
                                    placeholder={t("provider.choose-type-rate")}
                                    onChange={(vals) => {
                                        setProviderTypeId(vals ? vals.map(val => val.value) : [])
                                    }}
                                    disabled={props.showLoading}
                                    required
                                    options={props.providerTypes?.map((opt)=>{return {label:opt.nameFr,value:opt.id}})}
                                    style={{
                                    lineHeight: '40px',
                                    color: '#7e7e7e',
                                    paddingLeft: ' 15px',
                                    }}
                                />
                            </div>
                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t("provider.number-autho")}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <input type='text' className='form-control'
                                    value={numeroAutorisation}
                                    disabled={props.showLoading}
                                    required
                                    onChange={(e) => setNumeroAutorisation(e.target.value)}
                                    />
                            </div>
                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t('common.email')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div className='input-group mb-3 input-success-o'>
                                    <div className='input-group-prepend'>
                                        <span className='input-group-text'>
                                            <i className='fa fa-at' />
                                        </span>
                                    </div>
                                    <input type='email' className='form-control'
                                        value={email}
                                        disabled={props.showLoading}
                                        required
                                        onChange={(e) => setEmail(e.target.value)}
                                        />
                                </div>
                            </div>
                        </div> 
                        <div className='row justify-content-between align-items-center'>
                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>Whatsapp</strong>
                                </label>
                                
                                <div className='input-group mb-3 input-success-o'>
                                    <PhoneInput
                                        country='cd'
                                        onlyCountries={['cm','ci','cd']}
                                        localization='fr'
                                        value={whatsappPhone}
                                        autoFormat={whatsappPhone ? !whatsappPhone.startsWith('225') : true}
                                        onChange={phone => setWhatsappPhone(phone)}
                                    />
                                </div>
                            </div>
                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t("client.phone")}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div className='input-group mb-3 input-success-o'>
                                    <PhoneInput
                                        country='cd'
                                        onlyCountries={['cm','ci','cd']}
                                        localization='fr'
                                        value={phoneNumber}
                                        autoFormat={phoneNumber ? !phoneNumber.startsWith('225') : true}
                                        onChange={phone => setPhoneNumber(phone)}
                                    />
                                </div>
                            </div>
                            {!id && <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t("provider.default-user")}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <Select
                                    className="select-search"
                                    value={props.profilsData?.filter(elt => profilIds.includes(elt.id)).map(res => {return {label: res.nameFr, value: res.id}})}
                                    disabled={props.showLoading}
                                    placeholder={t("provider.choose-profil")}
                                    isMulti
                                    required
                                    onChange={(vals) => setProfilIds(vals ? vals.map(val => { return val.value }) : [])}
                                    options={props.profilsData?.map((opt)=>{return {label:opt.nameFr,value:opt.id}})}
                                    style={{
                                    lineHeight: '40px',
                                    color: '#7e7e7e',
                                    paddingLeft: ' 15px',
                                    }}
                                />
                            </div>}
                        </div>
                        
                        <div className='row justify-content-between align-items-center'>
                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t("provider.picture")} {t('dashboard.provider')}</strong>
                                </label>
                                <div>
                                    <div className='input-group'>
                                        <div className='custom-file'>
                                            <input type="file" disabled={props.showLoading} className='custom-file-input' onChange={(e) => saveFile(e)} />
                                            <label className='custom-file-label'>{imgSrc ? <small>{imgSrc.name}</small> : 'Choisir'}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>Date de convention</strong>
                                </label>
                                <input 
                                    type='date' 
                                    className='form-control'
                                    value={conventionDate}
                                    disabled={props.showLoading}
                                    onChange={(e) => setConventionDate(e.target.value)}
                                />
                            </div>

                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>Status</strong>
                                </label>
                                <select
                                    value={status}
                                    className='form-control form-control-lg'
                                    onChange={(e) => setStatus(e.target.value === 'true')}
                                >
                                    <option value={true}>Actif</option>
                                    <option value={false}>Inactif</option>
                                </select>
                            </div>
                        </div>
                            
                        <div className='row justify-content-end px-2 align-items-center'>
                            <button type="button" className='btn btn-primary' disabled={!canGoNext(activeIndex)} onClick={e => setActiveIndex(activeIndex + 1)}>Suivant</button>
                        </div>
                    </div>}
                    {activeIndex === 1 && <div className='px-5 pt-5'>
                        <div className='row justify-content-between align-items-center'>
                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t("provider.convention-number")}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <input type='text' className='form-control'
                                    value={conventionNumber}
                                    disabled={props.showLoading}
                                    required
                                    onChange={(e) => setConventionNumber(e.target.value)}
                                />
                            </div>

                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>NIU</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <input type='text' className='form-control'
                                    value={niu}
                                    disabled={props.showLoading}
                                    required
                                    onChange={(e) => setNiu(e.target.value)}
                                    />
                            </div>
                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.type-tax')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <select
                                    value={taxType}
                                    disabled={props.showLoading}
                                    className='form-control form-control-lg'
                                    required
                                    onChange={(e) => setTaxType(e.target.value)}
                                >
                                    <option value=''>
                                        {t("common.choose")}
                                    </option>
                                    <option value='fonciere'> {t("provider.property")}</option>
                                    <option value='luxe'>{t("provider.luxury")}</option>
                                    <option value='audiovisuelle'>{t("provider.audiovisual")}</option>
                                </select>
                            </div>
                        </div>

                        <div className='row justify-content-between align-items-center'>
                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t("provider.tax-value")}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <input disabled={props.showLoading} type='text' className='form-control'
                                value={taxValue}
                                required
                                onChange={(e) => setTaxValue(e.target.value)}
                                />
                                
                            </div>
                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t("provider.taxpayer-number")}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <input disabled={props.showLoading} type='text' className='form-control'
                                    value={contribuable}
                                    required
                                    onChange={(e) => setContribuable(e.target.value)}
                                    />
                            </div>
                            <div className='col-4 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.years-tax-validity')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <input required disabled={props.showLoading} type='number' className='form-control'
                                    value={exerciceYear}
                                    onChange={(e) => setExerciceYear(e.target.value)}
                                    />
                            </div>
                        </div>

                        <div className='row justify-content-end px-3 align-items-center'>
                            <button type="button" className='btn btn-info mr-2' onClick={e => setActiveIndex(activeIndex - 1)}>{t('provider.previous')}</button>
                            <button type="button" className='btn btn-primary' disabled={!canGoNext(activeIndex)} onClick={e => setActiveIndex(activeIndex + 1)}>Suivant</button>
                        </div>
                    </div>}
                    {activeIndex === 2 && <div className='px-5 pt-5'>
                        <div className='row justify-content-between align-items-center'>
                            <div className='col-5 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t('common.country')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <Select
                                    className="select-search"
                                    value={props.admin.countries?.filter(elt => elt.id === countryId).map((opt)=>{return {label:opt.name,value:opt.id}})}
                                    isDisabled={props.showLoading}
                                    placeholder={t('common.choose-country')}
                                    required
                                    onChange={(val) => {
                                        if(val !== '') {
                                            setChoosenCountry(props.admin.countries?.filter((country) =>{return country.id === val.value}))
                                            setCountryId(val.value);
                                        }
                                    }}
                                    options={props.admin.countries?.map((opt)=>{return {label:opt.name,value:opt.id}})}
                                    style={{
                                    lineHeight: '40px',
                                    color: '#7e7e7e',
                                    paddingLeft: ' 15px',
                                    }}
                                />
                            </div>
                            <div className='col-5 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t('client.city')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <Select
                                    className="select-search"
                                    value={choosenCountry[0]?.city.filter(elt => elt.id === cityId).map((opt)=>{return {label:opt.name,value:opt.id}})}
                                    isDisabled={props.showLoading || choosenCountry.length === 0}
                                    placeholder={t('common.choose-city')}
                                    required
                                    onChange={(val) => {
                                        setCityId(val.value)
                                    }}
                                    options={choosenCountry[0]?.city.map((opt)=>{return {label:opt.name,value:opt.id}})}
                                    style={{
                                    lineHeight: '40px',
                                    color: '#7e7e7e',
                                    paddingLeft: ' 15px',
                                    }}
                                />
                            </div>
                            
                            <div className='col-2 form-group'>
                                <label className='mb-1 '>
                                    <strong>{t('client.postalCode')}</strong>
                                </label>
                                <input disabled={props.showLoading} type='text' className='form-control'
                                    value={postal}
                                    onChange={(e) => setPostal(e.target.value)}
                                    />
                            </div>
                        </div>
                        
                        <div className='row justify-content-between align-items-center'>

                            <div className='col-5 form-group'>
                                <label className='mb-1 '>
                                    <strong>Latitude</strong>
                                </label>
                                <input  disabled={props.showLoading} type='number' className='form-control'
                                    value={lat}
                                    onChange={(e) => setLat(e.target.value)}
                                    />
                            </div>
                            <div className='col-5 form-group'>
                                <label className='mb-1 '>
                                    <strong>Longitude</strong>
                                </label>
                                <input  disabled={props.showLoading} type='number' className='form-control'
                                    value={lon}
                                    onChange={(e) => setLon(e.target.value)}
                                    />
                            </div>
                        </div>
                        <div className='row justify-content-end px-3 align-items-center'>
                            <button type="button" className='btn btn-info mr-2' onClick={e => setActiveIndex(activeIndex - 1)}>{t('provider.previous')}</button>
                            <button type="button" className='btn btn-primary' disabled={!canGoNext(activeIndex)} onClick={e => setActiveIndex(activeIndex + 1)}>Suivant</button>
                        </div>
                    </div>}
                    {activeIndex === 3 && <div className='px-5 pt-5'>
                        <h5 className='mt-4 text-primary'>Détails Bancaires</h5>
                        <div className="border-top mt-2 mb-4"></div>
                        
                        {bankDetails.map((bankDetail, index) => (
                            <div key={bankDetail.id || index} className="border rounded p-3 mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="text-secondary mb-0">Compte Bancaire {index + 1}</h6>
                                    {bankDetails.length > 1 && (
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            onClick={() => removeBankDetail(index)}
                                        >
                                            Supprimer
                                        </Button>
                                    )}
                                </div>
                                
                                <div className='row justify-content-between align-items-center'>
                                    <div className='col-4 form-group'>
                                        <label className='mb-1'>
                                            <strong>Nom de la banque</strong>
                                        </label>
                                        <input 
                                            type='text' 
                                            className='form-control'
                                            value={bankDetail.bankName}
                                            onChange={(e) => updateBankDetail(index, 'bankName', e.target.value)}
                                            disabled={props.showLoading}
                                        />
                                    </div>
                                    <div className='col-4 form-group'>
                                        <label className='mb-1'>
                                            <strong>Nom du titulaire</strong>
                                            {bankDetail.bankName.trim().length > 0 && <span className='text-danger ml-1'>*</span>}
                                        </label>
                                        <input 
                                            type='text' 
                                            className='form-control'
                                            value={bankDetail.accountName}
                                            onChange={(e) => updateBankDetail(index, 'accountName', e.target.value)}
                                            disabled={props.showLoading || bankDetail.bankName.trim().length === 0}
                                            required={bankDetail.bankName.trim().length > 0}
                                        />
                                    </div>
                                    <div className='col-4 form-group'>
                                        <label className='mb-1'>
                                            <strong>RIB Photo</strong>
                                            {bankDetail.bankName.trim().length > 0 && <span className='text-danger ml-1'>*</span>}
                                        </label>
                                        <div className='input-group'>
                                            <div className='custom-file'>
                                                <input 
                                                    type="file" 
                                                    className='custom-file-input' 
                                                    onChange={(e) => addRIB(e, index)}
                                                    disabled={props.showLoading || bankDetail.bankName.trim().length === 0}
                                                    required={bankDetail.bankName.trim().length > 0 && !bankDetail.ribPhoto}
                                                />
                                                <label className='custom-file-label'>
                                                    {bankDetail.ribPhoto ? 
                                                        <small>{typeof bankDetail.ribPhoto === 'string' ? bankDetail.ribPhoto : bankDetail.ribPhoto.name}</small> : 
                                                        'Choisir un fichier'
                                                    }
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className='row justify-content-between align-items-center'>
                                    <div className='col-3 form-group'>
                                        <label className='mb-1'>
                                            <strong>Numéro de compte</strong>
                                            {bankDetail.bankName.trim().length > 0 && <span className='text-danger ml-1'>*</span>}
                                        </label>
                                        <input 
                                            type='text' 
                                            className='form-control'
                                            value={bankDetail.accountNumber}
                                            onChange={(e) => updateBankDetail(index, 'accountNumber', e.target.value)}
                                            disabled={props.showLoading || bankDetail.bankName.trim().length === 0}
                                            required={bankDetail.bankName.trim().length > 0}
                                        />
                                    </div>
                                    <div className='col-3 form-group'>
                                        <label className='mb-1'>
                                            <strong>Code banque</strong>
                                            {bankDetail.bankName.trim().length > 0 && <span className='text-danger ml-1'>*</span>}
                                        </label>
                                        <input 
                                            type='text' 
                                            className='form-control'
                                            value={bankDetail.bankCode}
                                            onChange={(e) => updateBankDetail(index, 'bankCode', e.target.value)}
                                            disabled={props.showLoading || bankDetail.bankName.trim().length === 0}
                                            required={bankDetail.bankName.trim().length > 0}
                                        />
                                    </div>
                                    <div className='col-3 form-group'>
                                        <label className='mb-1'>
                                            <strong>Clé RIB</strong>
                                            {bankDetail.bankName.trim().length > 0 && <span className='text-danger ml-1'>*</span>}
                                        </label>
                                        <input 
                                            type='text' 
                                            className='form-control'
                                            value={bankDetail.rib}
                                            onChange={(e) => updateBankDetail(index, 'rib', e.target.value)}
                                            disabled={props.showLoading || bankDetail.bankName.trim().length === 0}
                                            required={bankDetail.bankName.trim().length > 0}
                                        />
                                    </div>
                                    <div className='col-3 form-group'>
                                        <label className='mb-1'>
                                            <strong>Code SWIFT</strong>
                                            {bankDetail.bankName.trim().length > 0 && <span className='text-danger ml-1'>*</span>}
                                        </label>
                                        <input 
                                            type='text' 
                                            className='form-control'
                                            value={bankDetail.swift}
                                            onChange={(e) => updateBankDetail(index, 'swift', e.target.value)}
                                            disabled={props.showLoading || bankDetail.bankName.trim().length === 0}
                                            required={bankDetail.bankName.trim().length > 0}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                        
                        <div className='row justify-content-start mb-4 align-items-center'>
                            <Button
                                variant="outline-primary"
                                className="ml-3"
                                onClick={addBankDetail}
                                disabled={props.showLoading}
                            >
                                + Ajouter un compte bancaire
                            </Button>
                        </div>

                        <h5 className='mt-4 text-primary'>Moyens de Paiement Mobile</h5>
                        <div className="border-top my-2 mb-4"></div>
                        
                        {mobilePaymentDetails.map((paymentDetail, index) => (
                            <div key={paymentDetail.id || index} className="border rounded p-3 mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="text-secondary mb-0">Paiement Mobile {index + 1}</h6>
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() => setMobilePaymentDetails(mobilePaymentDetails.filter((_, i) => i !== index))}
                                        disabled={props.showLoading}
                                    >
                                        Supprimer
                                    </Button>
                                </div>
                                
                                <div className='row justify-content-between align-items-center'>
                                    <div className='col-4 form-group'>
                                        <label className='mb-1'>
                                            <strong>Opérateur</strong>
                                            <span className='text-danger ml-1'>*</span>
                                        </label>
                                        <select
                                            value={paymentDetail.operator}
                                            className='form-control form-control-lg'
                                            onChange={(e) => setMobilePaymentDetails(mobilePaymentDetails.map(mpd => 
                                                mpd.id === paymentDetail.id ? {...mpd, operator: e.target.value} : mpd
                                            ))}
                                            disabled={props.showLoading}
                                            required
                                        >
                                            <option value=''>Choisir un opérateur</option>
                                            <option value='om'>Orange Money</option>
                                            <option value='momo'>MTN Mobile Money</option>
                                        </select>
                                    </div>
                                    <div className='col-4 form-group'>
                                        <label className='mb-1'>
                                            <strong>Numéro de téléphone</strong>
                                            <span className='text-danger ml-1'>*</span>
                                        </label>
                                        <PhoneInput
                                            country='cd'
                                            onlyCountries={['cm','ci','cd']}
                                            localization='fr'
                                            value={paymentDetail.phoneNumber}
                                            autoFormat={paymentDetail.phoneNumber ? !paymentDetail.phoneNumber.startsWith('225') : true}
                                            onChange={phone => setMobilePaymentDetails(mobilePaymentDetails.map(mpd => 
                                                mpd.id === paymentDetail.id ? {...mpd, phoneNumber: phone} : mpd
                                            ))}
                                            disabled={props.showLoading}
                                        />
                                    </div>
                                    <div className='col-4 form-group'>
                                        <label className='mb-1'>
                                            <strong>Nom complet du bénéficiaire</strong>
                                            <span className='text-danger ml-1'>*</span>
                                        </label>
                                        <input 
                                            type='text' 
                                            className='form-control'
                                            value={paymentDetail.beneficialName}
                                            onChange={(e) => setMobilePaymentDetails(mobilePaymentDetails.map(mpd => 
                                                mpd.id === paymentDetail.id ? {...mpd, beneficialName: e.target.value} : mpd
                                            ))}
                                            disabled={props.showLoading}
                                            required={paymentDetail.operator.length > 0}
                                        />
                                    </div>
                                </div>
                                
                                <div className='row justify-content-between align-items-center'>
                                    <div className='col-3 form-group'>
                                        <label className='mb-1'>
                                            <strong>Type de pièce d'identité</strong>
                                            <span className='text-danger ml-1'>*</span>
                                        </label>
                                        <select
                                            value={paymentDetail.idType}
                                            className='form-control form-control-lg'
                                            onChange={(e) => setMobilePaymentDetails(mobilePaymentDetails.map(mpd => 
                                                mpd.id === paymentDetail.id ? {...mpd, idType: e.target.value} : mpd
                                            ))}
                                            disabled={props.showLoading}
                                            required={paymentDetail.operator.length > 0}
                                        >
                                            <option value=''>Choisir un type</option>
                                            <option value='cni'>Carte d'identité</option>
                                            <option value='passeport'>Passeport</option>
                                            <option value='contribuable'>Carte contribuable</option>
                                        </select>
                                    </div>
                                    <div className='col-4 form-group'>
                                        <label className='mb-1'>
                                            <strong>Numéro de la pièce</strong>
                                            <span className='text-danger ml-1'>*</span>
                                        </label>
                                        <input 
                                            type='text' 
                                            className='form-control'
                                            value={paymentDetail.idNumber}
                                            onChange={(e) => setMobilePaymentDetails(mobilePaymentDetails.map(mpd => 
                                                mpd.id === paymentDetail.id ? {...mpd, idNumber: e.target.value} : mpd
                                            ))}
                                            disabled={props.showLoading}
                                            required={paymentDetail.operator.length > 0}
                                        />
                                    </div>
                                    <div className='col-4 form-group'>
                                        <label className='mb-1'>
                                            <strong>Photo de la pièce</strong>
                                            <span className='text-danger ml-1'>*</span>
                                        </label>
                                        <div className='input-group'>
                                            <div className='custom-file'>
                                                <input 
                                                    type="file" 
                                                    className='custom-file-input' 
                                                    onChange={(e) => loadIdentityFile(e, paymentDetail)}
                                                    disabled={props.showLoading}
                                                    required={paymentDetail.operator.length > 0 && !paymentDetail.file && !paymentDetail.idPhoto}
                                                />
                                                <label className='custom-file-label'>
                                                    {paymentDetail.file ? 
                                                        <small>{paymentDetail.file.name}</small> : 
                                                        paymentDetail.idPhoto ?
                                                        <small>{paymentDetail.idPhoto}</small> :
                                                        'Choisir un fichier'
                                                    }
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        
                        <div className='row justify-content-start mb-4 align-items-center'>
                            <Button
                                variant="outline-primary"
                                className="ml-3"
                                onClick={() => setMobilePaymentDetails([...mobilePaymentDetails, {
                                    id: Math.random(),
                                    operator: "",
                                    phoneNumber: "",
                                    beneficialName: "",
                                    idType: "",
                                    idNumber: "",
                                    file: null,
                                    idPhoto: null
                                }])}
                                disabled={props.showLoading}
                            >
                                + Ajouter un moyen de paiement mobile
                            </Button>
                        </div>

                        <div className='row justify-content-end px-3 align-items-center'>
                            <button type="button" className='btn btn-info mr-2' onClick={e => setActiveIndex(activeIndex - 1)}>
                                Précédent
                            </button>
                            <button type="button" className='btn btn-primary' disabled={!canGoNext(activeIndex)} onClick={e => setActiveIndex(activeIndex + 1)}>
                                Suivant
                            </button>
                        </div>
                    </div>}
                    {activeIndex === 4 && <div className='px-5 pt-5'>
                        <div className='row justify-content-start mb-2 align-items-center'>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.promoter')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div>
                                    <span className='text-primary'>{identity}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.denomination')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div>
                                    <span className='text-primary'>{providerName}</span>
                                </div>
                            </div>
                            {(identity === 'Promoteur') && <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.gouv-number')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div>
                                    <span className='text-primary'>{numeroAutorisationGouv}</span>
                                </div>
                            </div>}
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.number-autho')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div>
                                    <span className='text-primary'>{numeroAutorisation}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('client.type')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div>
                                    <span className='text-primary'>{props.providerTypes?.filter(elt => providerTypeId.includes(elt.id))?.map(elt => {return elt.nameFr}).join(', ')}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('common.email')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div>
                                    <span className='text-primary'>{email}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>Whatsapp</strong>
                                </label>
                                <div>
                                    <span className='text-primary'>{whatsappPhone}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.phone')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div>
                                    <span className='text-primary'>{phoneNumber}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.default-user')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div>
                                    <span className='text-primary'>{props.profilsData?.filter(elt => profilIds.includes(elt.id))?.map(elt => {return elt.nameFr}).join(', ')}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.picture')}</strong>
                                </label>
                                <div>
                                    <span className='text-primary'>{imgSrc?.name}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>Status</strong>
                                </label>
                                <div>
                                    <span className='text-primary'>{status ? 'Actif' : 'Inactif'}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>Date de convention</strong>
                                </label>
                                <div>
                                    <span className='text-primary'>{conventionDate}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.convention-number')}</strong>
                                </label>
                                <div>
                                    <span className='text-primary'>{conventionNumber}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>NIU</strong>
                                </label>
                                <div>
                                    <span className='text-primary'>{niu}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.type-tax')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div>
                                    <span className='text-primary'>{taxType}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.tax-value')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div>
                                    <span className='text-primary'>{taxValue}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.taxpayer-number')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div>
                                    <span className='text-primary'>{contribuable}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.years-tax-validity')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div>
                                    <span className='text-primary'>{exerciceYear}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.country')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div>
                                    <span className='text-primary'>{choosenCountry[0]?.name}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong> {t('provider.city')}</strong>
                                    <span className='text-danger ml-1'>*</span>
                                </label>
                                <div>
                                    <span className='text-primary'>{choosenCountry[0]?.city?.find(elt => elt.id === cityId)?.name}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.postal-code')}</strong>
                                </label>
                                <div>
                                    <span className='text-primary'>{postal}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>Latitude</strong>
                                </label>
                                <div>
                                    <span className='text-primary'>{lat}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>Longitude</strong>
                                </label>
                                <div>
                                    <span className='text-primary'>{lon}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.bank')}</strong>
                                </label>
                                <div>
                                    <span className='text-primary'>{bankDetail.bankName}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.title-account')}</strong>
                                    {bankDetail.bankName.trim().length > 0 && <span className='text-danger ml-1'>*</span>}
                                </label>
                                <div>
                                    <span className='text-primary'>{bankDetail.accountName}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>RIB</strong>
                                    {bankDetail.bankName.trim().length > 0 && <span className='text-danger ml-1'>*</span>}
                                </label>
                                <div>
                                    <span className='text-primary'>{bankDetail.ribPhoto?.name}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.account-number')}</strong>
                                    {bankDetail.bankName.trim().length > 0 && <span className='text-danger ml-1'>*</span>}
                                </label>
                                <div>
                                    <span className='text-primary'>{bankDetail.accountNumber}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.bank-code')}</strong>
                                    {bankDetail.bankName.trim().length > 0 && <span className='text-danger ml-1'>*</span>}
                                </label>
                                <div>
                                    <span className='text-primary'>{bankDetail.bankCode}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.key-RIB')}</strong>
                                    {bankDetail.bankName.trim().length > 0 && <span className='text-danger ml-1'>*</span>}
                                </label>
                                <div>
                                    <span className='text-primary'>{bankDetail.rib}</span>
                                </div>
                            </div>
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>{t('provider.swift-code')}</strong>
                                    {bankDetail.bankName.trim().length > 0 && <span className='text-danger ml-1'>*</span>}
                                </label>
                                <div>
                                    <span className='text-primary'>{bankDetail.swift}</span>
                                </div>
                            </div>
                            {paymentMeans.length > 0 && 
                                <div className='col-12'>
                                    <h6 className='text-primary mt-3 mb-2'>Moyens de paiement mobile:</h6>
                                    {paymentMeans.map((elt, index) => {
                                        return (
                                            <div key={elt.id} className='row border-bottom pb-2 mb-2'>
                                                <div className='col-3'>
                                                    <label className='mb-1 '>
                                                        <strong>{t('provider.operator')}</strong>
                                                        <span className='text-danger ml-1'>*</span>
                                                    </label>
                                                    <div>
                                                        <span className='text-primary'>{elt.operator}</span>
                                                    </div>
                                                </div>
                                                <div className='col-3'>
                                                    <label className='mb-1 '>
                                                        <strong>{t('provider.phone-number')}</strong>
                                                        <span className='text-danger ml-1'>*</span>
                                                    </label>
                                                    <div>
                                                        <span className='text-primary'>{elt.phoneNumber}</span>
                                                    </div>
                                                </div>
                                                <div className='col-3'>
                                                    <label className='mb-1 '>
                                                        <strong> {t('provider.ownerfullname')}</strong>
                                                        <span className='text-danger ml-1'>*</span>
                                                    </label>
                                                    <div>
                                                        <span className='text-primary'>{elt.beneficialName}</span>
                                                    </div>
                                                </div>
                                                <div className='col-3'>
                                                    <label className='mb-1 '>
                                                        <strong>{t('provider.typeIdenDoc')}</strong>
                                                        <span className='text-danger ml-1'>*</span>
                                                    </label>
                                                    <div>
                                                        <span className='text-primary'>{elt.idType}</span>
                                                    </div>
                                                </div>
                                                <div className='col-3'>
                                                    <label className='mb-1 '>
                                                        <strong>{t('provider.identifier-number')}</strong>
                                                        <span className='text-danger ml-1'>*</span>
                                                    </label>
                                                    <div>
                                                        <span className='text-primary'>{elt.idNumber}</span>
                                                    </div>
                                                </div>
                                                <div className='col-3'>
                                                    <label className='mb-1 '>
                                                        <strong>{t('provider.ident-doc')}</strong>
                                                        <span className='text-danger ml-1'>*</span>
                                                    </label>
                                                    <div>
                                                        <span className='text-primary'>{elt.file?.name}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            }
                            
                            <div className='col-3'>
                                <label className='mb-1 '>
                                    <strong>Tarif ID</strong>
                                </label>
                                <div>
                                    <span className='text-primary'>{tarifId}</span>
                                </div>
                            </div>
                        </div>
                        
                        <div className='row justify-content-end px-3 align-items-center'>
                            { props.showLoading && 
                            <Button variant="primary" disabled>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />{' '}
                                <span className="visually-hidden">{t('common.await-text')}</span>
                            </Button> }
                            { !props.showLoading &&
                            <>
                                <button type="button" className='btn btn-info mr-2' onClick={e => setActiveIndex(activeIndex - 1)}>{t('provider.previous')}</button>
                                <input type='submit' disabled={!canSubmitForm()} value={t('common.save')} className='btn btn-primary'/>
                            </> }
                        </div>
                    </div>}
                </form>
            </div>}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        provider: state.provider.provider,
        providers: state.provider.providers,
        countries: state.parameters.countries,
        admin: state.admin.administration,
        providerTypes: state.provider.providerTypes,
        errorMessage: state.clientAuth.errorMessage,
        successMessage: state.clientAuth.successMessage,
        showLoading: state.provider.showLoading,
        profilsData: state.user.profils,
        currentUser: currentUser(state)
    };
};

export default withRouter(connect(mapStateToProps)(ProviderForm));